import { render } from "./SignatureAckCheckbox.vue?vue&type=template&id=a2488902&scoped=true"
import script from "./SignatureAckCheckbox.vue?vue&type=script&lang=js"
export * from "./SignatureAckCheckbox.vue?vue&type=script&lang=js"

import "./SignatureAckCheckbox.vue?vue&type=style&index=0&id=a2488902&lang=scss&scoped=true"

import exportComponent from "/app/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a2488902"]])

export default __exports__